





































import Vue from "vue";
import { Header } from "@/components/MyTable.vue";
import { ListHeader } from "@/components/MyListCard.vue";
import { axios } from "../../../plugins";

const AlarmRulesHeader: Header[] = [
  { title: "名称", key: "metadata.name", minWidth: 200 },
  { title: "状态", key: "", width: 140 },
  { title: "主机名称(IP)", key: "spec.nodeName", width: 200 },
  { title: "容器组IP", key: "", width: 150 },
  { title: "创建时间", key: "", width: 178 }
];

const infoHeader: ListHeader[] = [
  { title: "任务名称", key: "name" },
  { title: "任务描述", key: "description" },
  { title: "最大重试次数", key: "backoffLimit" },
  { title: "完成数", key: "completions" },
  { title: "并行数", key: "parallelism" },
  { title: "退出超时时限(秒)", key: "activeDeadlineSeconds" }
];
export default Vue.extend({
  name: "Overview",
  props: {
    data: { type: Object },
    kind: { type: String },
    projectId: { type: String }
  },
  data() {
    return {
      AlarmRulesHeader,
      infoHeader,
      tableData: []
    };
  },
  mounted() {
    this.getTable();
  },
  watch: {
    data() {
      this.getTable();
    }
  },
  methods: {
    getTable() {
      axios
        .get(`/jobs/${this.projectId}/job/${this.data.name}/pods`)
        .then(res => {
          this.tableData = res.data.data;
        });
    },
    showTaskInfo(data: any) {
      this.$router.push({
        name: "PrjContainers",
        query: { name: data.metadata.name || "" }
      });
    }
  }
});
